import { OnboardingNotifications } from '../../../models/OnboardingNotifications';
import { User } from '../../../models/User';

export const GET_USER = 'GET_USER';
export type GET_USER = typeof GET_USER;

export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';
export type REDIRECT_TO_LOGIN = typeof REDIRECT_TO_LOGIN;

export const GET_ONBOARDING_NOTIFICATIONS = 'GET_ONBOARDING_NOTIFICATIONS';
export type GET_ONBOARDING_NOTIFICATIONS = typeof GET_ONBOARDING_NOTIFICATIONS;

export interface GetNotificationsAction {
    type: GET_ONBOARDING_NOTIFICATIONS;
    payload: {
        onboardingData: OnboardingNotifications;
    };
}

export interface GetUserAction {
    type: GET_USER;
    payload: {
        user: User;
    };
}

export interface RedirectToLoginAction {
    type: REDIRECT_TO_LOGIN;
    payload: {};
}

export type UserActions = GetUserAction | GetNotificationsAction | RedirectToLoginAction;
